export default __webpack_public_path__ + "be7b8b6ec79c2a3b50a7d28e5f638576.png";